import { render, staticRenderFns } from "./OldPnrInformations.vue?vue&type=template&id=0ee5b3dc&scoped=true"
import script from "./OldPnrInformations.vue?vue&type=script&lang=js"
export * from "./OldPnrInformations.vue?vue&type=script&lang=js"
import style0 from "./OldPnrInformations.vue?vue&type=style&index=0&id=0ee5b3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee5b3dc",
  null
  
)

export default component.exports